import { z } from "zod";

import { ERROR_TYPE } from "@/utils";
import { TokenStatus } from "@/enum";

const { REQUIRED } = ERROR_TYPE;

export const VerifyEmailRequestSchema = z.object({
	token: z.string().min(1, { message: REQUIRED }),
});

export type VerifyEmailBody = z.infer<typeof VerifyEmailRequestSchema>;

export const VerifyEmailResponseSchema = z.object({
	status: z.nativeEnum(TokenStatus),
});

export type VerifyEmailResponse = z.infer<typeof VerifyEmailResponseSchema>;
